(function (module) {
    'use strict';

    function TermsCtrl($state, Store, Account) {

    }

    module
        .config(function ($stateProvider) {

            // Route
            $stateProvider
                .state('terms', {
                    url: '/terms',
                    data: {
                        pageTitle: 'Terms and Conditions'
                    },
                    views: {
                        'main@': {
                            templateUrl: '/js/components/layouts/content-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@terms': {
                            template: '<terms-component />'
                        }
                    },

                    bodyClass: 'page--terms'

                    // Translations
                    // $translatePartialLoaderProvider.addPart('/js/authentication/conditions');

                });
        })
        .component('termsComponent', {
            templateUrl: '/js/authentication/terms-conditions/terms-conditions.html',
            controller: TermsCtrl,
            bindings: {
                account: '<'
            }
        });

})

(angular.module('rocket.components'));
